import React from "react";
import { useResubmitPrompt } from "../hooks/useResubmitPrompt";

const RESUBMIT_REASON_MAX_LENGTH = 1000;

export default function ResubmitAfterEditDialog({ open, onResubmit, onDismiss }) {
  const dialogRef = React.useRef(null);
  const reasonRef = React.useRef(null);
  const {
    reason,
    setReason,
    resubmitting,
    errorMessage,
    canResubmit,
    confirmResubmission,
    dismiss
  } = useResubmitPrompt({ open, onResubmit, onDismiss });

  React.useEffect(() => {
    if (open) {
      dialogRef.current?.showModal();
      reasonRef.current?.focus();
    } else {
      dialogRef.current?.close();
    }
  }, [open]);

  return (
    <dialog
      ref={dialogRef}
      className="resubmit-after-edit-dialog"
      aria-labelledby="resubmit-after-edit-title"
      aria-describedby="resubmit-after-edit-description"
      onCancel={(event) => {
        event.preventDefault();
        dismiss();
      }}
      onClick={(event) => {
        if (event.target === dialogRef.current) {
          dismiss();
        }
      }}
    >
      <div className="resubmit-after-edit-dialog-inner">
        <h2 id="resubmit-after-edit-title">Send your updated timecard?</h2>
        <p id="resubmit-after-edit-description">
          This timecard was previously submitted. Would you like to send the updated timecard now?
        </p>

        <label htmlFor="resubmit-after-edit-reason">
          Reason for the update
        </label>
        <textarea
          ref={reasonRef}
          id="resubmit-after-edit-reason"
          className="resubmit-reason-input"
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          maxLength={RESUBMIT_REASON_MAX_LENGTH}
          rows={3}
          disabled={resubmitting}
        />

        {errorMessage ? (
          <div className="status-message error" role="alert">
            {errorMessage}
          </div>
        ) : null}

        <div className="resubmit-after-edit-actions">
          <button
            type="button"
            className="primary-action"
            onClick={confirmResubmission}
            disabled={!canResubmit}
          >
            {resubmitting ? "Resubmitting…" : "Yes, resubmit"}
          </button>
          <button
            type="button"
            className="secondary-action"
            onClick={dismiss}
            disabled={resubmitting}
          >
            No, not now
          </button>
        </div>
      </div>
    </dialog>
  );
}
